import React from 'react';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { MaintenanceReportCategories } from '../MaintenanceReportCategories';
import { Layout } from '@singularsystems/neo-canvas-grid';
import CheckQueryConfigStatusReportCriteria from './CheckQueryConfigStatusReportCriteria';
import { AppService, Types } from '../../../App/Services/AppService';

@NeoReport("CheckQueryConfigStatusWIP",  { category: MaintenanceReportCategories.SystemInformationReports})
export default class CheckQueryConfigStatusReport extends Report<CheckQueryConfigStatusReportCriteria>{
    constructor(
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient)
    ) {
        super(CheckQueryConfigStatusReportCriteria);
    }

    public renderCriteria() {
        return (
        <>
        </>);
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}